import Modal from "@app/components/modal/modal.component";
import { PortalDialogProps } from "@app/services/modal.service";
import { BookEbookPreviewPage } from "@app/types";

interface EbookPreviewModalProps {
  title?: string;
  previewUrl?: string;
  pageCount?: number;
  pages?: BookEbookPreviewPage[];
}

function EbookPreviewModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<EbookPreviewModalProps>) {
  const pages = portalData?.pages ?? [];

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[1080px] max-w-[96vw] px-6 py-7">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-xl font-semibold text-black">
              {portalData?.title ?? "Preview Ebook"}
            </div>
            {!!portalData?.pageCount && (
              <div className="mt-1 text-sm text-[#83898C]">
                Tổng số trang: {portalData.pageCount}
              </div>
            )}
          </div>
        </div>

        {portalData?.previewUrl ? (
          <iframe
            title="ebook-preview"
            src={portalData.previewUrl}
            className="mt-6 h-[80vh] w-full rounded-xl border border-[#E5E7EB]"
          />
        ) : (
          <div className="mt-6 max-h-[80vh] overflow-y-auto rounded-xl border border-[#E5E7EB] bg-[#FAFBFC] p-5">
            {pages.length ? (
              <div className="space-y-4">
                {pages.map((page) => (
                  <div
                    key={page.page}
                    className="rounded-xl bg-white p-4 shadow-[0_1px_3px_rgba(0,0,0,0.06)]"
                  >
                    <div className="mb-3 text-sm font-semibold text-[#343C6A]">
                      Trang {page.page}
                    </div>
                    <div className="whitespace-pre-wrap text-sm leading-7 text-[#3A4251]">
                      {page.content || "Trang này không có nội dung text để hiển thị."}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-sm text-[#83898C]">
                Không có dữ liệu preview để hiển thị.
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}

export default EbookPreviewModal;
